
import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { processSteps } from '../../../mocks/services';

const fadeInUp = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12 },
  },
};

export default function ProcessSteps() {
  // Create a ref that can be attached to a DOM element.
  const ref = useRef<HTMLDivElement>(null);

  // Guard against the ref being null on the very first render.
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px',
  });

  return (
    <section className="py-20 px-6 bg-gray-50" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
          variants={staggerContainer}
          className="text-center mb-16"
        >
          <motion.p
            variants={fadeInUp}
            className="text-sm text-red-600 font-medium mb-3"
          >
            Adım Adım
          </motion.p>
          <motion.h2
            variants={fadeInUp}
            className="text-5xl font-bold text-gray-900 mb-4"
          >
            ÇALIŞMA SÜRECİMİZ
          </motion.h2>
          <motion.p
            variants={fadeInUp}
            className="text-gray-600 max-w-2xl mx-auto"
          >
            Keşiften kuruluma, eğitimden bakıma kadar her aşamada profesyonel
            hizmet sunuyoruz.
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
          variants={staggerContainer}
          className="relative"
        >
          {/* Connection line */}
          <div className="hidden md:block absolute top-24 left-[10%] right-[10%] h-0.5 bg-red-100"></div>

          <div className="grid md:grid-cols-5 gap-8">
            {processSteps.map((step, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="relative text-center group"
              >
                <motion.div
                  whileHover={{ scale: 1.1, y: -5 }}
                  className="w-20 h-20 flex items-center justify-center bg-white border-2 border-red-100 rounded-full mx-auto mb-5 relative z-10 group-hover:border-red-400 group-hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <i className={`${step.icon} text-3xl text-red-600`}></i>
                </motion.div>

                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-7 h-7 flex items-center justify-center bg-red-600 text-white text-xs font-bold rounded-full z-20 -mt-1 -ml-8">
                  {step.step}
                </div>

                <h3 className="text-base font-bold text-gray-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
